export const genresList = [
    { id: 18, name: "Drama" },
    { id: 35, name: "Comedy" },
    { id: 99, name: "Documentary" },
    { id: 53, name: "Thriller" },
    { id: 878, name: "Science Fiction" },
    { id: 28, name: "Action" },
    {
        "id": 10749,
        "name": "Romance"
    }
]